module.exports = __webpack_public_path__ + "img/Antoinette.371e2fa7.png";